<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";
export default {
  name: "ChamberMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    /**
     * Loads the cabinet types
     *
     * @return {Array} - the array with the various cabinet types
     */
    typeOptions() {
      return this.$store.getters.optionLists_materialType;
    },

    fields() {
      return [
      {
          label: this.$i18n.tc("Manhole", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smch_chamber_type], this.typeOptions)
            : this.familySpecificFields.smch_chamber_type,
          varName: 'smch_chamber_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.typeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("Length") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smch_length,
          varName: 'smch_length',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.t("Width") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smch_width,
          varName: 'smch_width',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
        {
          label: this.$i18n.t("Depth") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smch_depth,
          varName: 'smch_depth',
          inputType: 'number',
          disabled: false,
          step: '.01',
          min: '0',
        },
      ]
    }
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smch_chamber_type && this.familySpecificFields.smch_chamber_type.length > 0
      );
    },

    isValidValue(value){
      if(!value || (value && value > 0 && this.isCompataibleWithSQLNumeric5_2(value))){
        return true;
      }
      return false;
    },
    isCompataibleWithSQLNumeric5_2(value){
      const regex = /^\d{1,3}(\.\d{1,2})?$/;
      return regex.test(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsChamber.vue